export type ActivityBreadcrumbFrom = 'news' | 'events';

const isDevelop = process.env.NODE_ENV === 'development';

export const ACTIVITY_BREADCRUMB_SECTIONS: Record<
  ActivityBreadcrumbFrom,
  { label: string; href: string }
> = isDevelop
  ? {
      news: { label: 'Новости', href: 'news-feed.html' },
      events: { label: 'Мероприятия', href: 'news-events-calendar.html' },
    }
  : {
      news: { label: 'Новости', href: '/news/' },
      events: { label: 'Мероприятия', href: '/news/calendar/' },
    };

const FROM_PARAM = 'from';

export function buildEventDetailUrl(from: ActivityBreadcrumbFrom = 'events'): string {
  return `event-detail.html?${FROM_PARAM}=${from}`;
}

export function buildActivityPageUrl(from: ActivityBreadcrumbFrom = 'events'): string {
  return buildEventDetailUrl(from);
}

export function buildNewsDetailUrl(from: ActivityBreadcrumbFrom = 'news'): string {
  return `news-detail.html?${FROM_PARAM}=${from}`;
}

export function buildNewsPageUrl(from: ActivityBreadcrumbFrom = 'news'): string {
  return buildNewsDetailUrl(from);
}

export function resolveActivityBreadcrumbFrom(
  search = window.location.search,
  referrer = document.referrer,
): ActivityBreadcrumbFrom {
  const param = new URLSearchParams(search).get(FROM_PARAM);
  if (param === 'news' || param === 'events') {
    return param;
  }

  const path = window.location.pathname;
  if (path.includes('/news/calendar') || path.includes('news-events-calendar')) {
    return 'events';
  }
  if (
    path.includes('event-detail') ||
    path.includes('news-activity') ||
    path.includes('news-events-calendar')
  ) {
    return 'events';
  }
  if (path.includes('news-feed') || path.includes('news-page') || path.includes('news-detail')) {
    return 'news';
  }
  if (/^\/news\/?$/.test(path) || (path.startsWith('/news/') && !path.includes('/calendar'))) {
    return 'news';
  }

  try {
    const refPath = new URL(referrer, window.location.origin).pathname;
    if (refPath.includes('/news/calendar') || refPath.includes('news-events-calendar')) {
      return 'events';
    }
    if (refPath.includes('news-feed') || refPath === '/news' || refPath === '/news/') {
      return 'news';
    }
  } catch {
    // ignore invalid referrer
  }

  return 'events';
}

export function initActivityPageBreadcrumb(root: ParentNode = document): void {
  const nav = root.querySelector<HTMLElement>('[data-page-breadcrumb]');
  if (!nav) return;

  const sectionLink = nav.querySelector<HTMLAnchorElement>('[data-breadcrumb-section]');
  const currentEl = nav.querySelector<HTMLElement>('[data-breadcrumb-current]');
  const titleEl = root.querySelector<HTMLElement>(
    '.activity-page__title, .news-detail__main-content--title, .event-detail__title',
  );

  const from = root.querySelector('.activity-page--news, .news-detail')
    ? 'news'
    : resolveActivityBreadcrumbFrom();
  const section = ACTIVITY_BREADCRUMB_SECTIONS[from];

  if (sectionLink) {
    sectionLink.href = section.href;
    sectionLink.textContent = section.label;
  }

  const title = titleEl?.textContent?.trim() ?? currentEl?.textContent?.trim() ?? '';
  if (currentEl && title) {
    currentEl.textContent = title;
  }
}
